import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SeoService } from './seo.service';

export const seoRouteResolver: ResolveFn<boolean> = (_route, state) => {
  inject(SeoService).resetForRoute(state.url);
  return true;
};
